import {
    createColumnHelper,
    flexRender,
    getCoreRowModel,
    getPaginationRowModel,
    useReactTable,
    getFilteredRowModel
} from "@tanstack/react-table";
import React, { useEffect, useMemo } from "react";
import { Pagination } from "./Pagination";
import Spinner from "react-bootstrap/Spinner";
import { forwardRef } from "react";
import { useImperativeHandle } from "react";


export const Table = forwardRef(({
    cols,
    data,
    loading,
    onPaginationChange,
    onSortingChange,
    onRowSelectionChange,
    globalFilter,
    onGlobalFilterChange,
    autoResetPageIndex,
    autoResetSelectedRows,
    enableRowSelection,
    getRowId,
    rowSelection,
    pageCount,
    pagination,
    sorting,
    onRowClick = null,
    canLoadMore,
    loadUser,
    manualPagination=true
}, ref) => {

    
    const table = useReactTable({
        data: data,
        columns: cols,
        state: {
            rowSelection,
            pagination,
            sorting,
            globalFilter: globalFilter
        },
        onRowSelectionChange: onRowSelectionChange,
        onPaginationChange: onPaginationChange,
        enableRowSelection: enableRowSelection,
        autoResetSelectedRows: autoResetSelectedRows,
        getRowId: getRowId,
        onGlobalFilterChange: onGlobalFilterChange,
        onSortingChange: onSortingChange,
        getPaginationRowModel: getPaginationRowModel(),
        getCoreRowModel: getCoreRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
        pageCount,
        manualPagination : manualPagination
        
    })

    if(manualPagination){
        table.getCanNextPage = () => canLoadMore
        table.nextPage = () => {
            table.setPagination(old => {
                const pageIndex = canLoadMore ? old.pageIndex + 1 : old.pageIndex
                return {
                    ...old,
                    pageIndex,
                }
            })
        }
    }
        

    useEffect(()=>{
        ref.current=table
    },[table])

    return (
        <div className='userTable'>
            <table>
                <thead>
                    {table.getHeaderGroups().map(headerGroup => (
                        <tr key={headerGroup.id}>
                            {headerGroup.headers.map(header => (
                                <th key={header.id}>
                                    {header.isPlaceholder
                                        ? null
                                        : flexRender(
                                            header.column.columnDef.header,
                                            header.getContext()
                                        )}
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody>
                    {loading ? (
                        <tr >
                        <td colSpan="100%">
                            <div className="d-flex justify-content-center">
                                    <Spinner className="mx-auto" style={{ color: "#436094" }} />
                            </div>
                            
                        </td>
                        </tr>
                    ) : (table.getRowModel().rows.map(row => (
                        <tr key={row.id} className={enableRowSelection && row?.getIsSelected() ? 'selected' : null} onDoubleClick={()=>onRowClick(row)}>
                            {row.getVisibleCells().map(cell => (
                                <td key={cell.id}>
                                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                </td>
                            ))}
                        </tr>
                    )))}
                </tbody>
                <tfoot>
                    {table.getFooterGroups().map(footerGroup => (
                        <tr key={footerGroup.id}>
                            {footerGroup.headers.map(header => (
                                <th key={header.id}>
                                    {header.isPlaceholder
                                        ? null
                                        : flexRender(
                                            header.column.columnDef.footer,
                                            header.getContext()
                                        )}
                                </th>
                            ))}
                        </tr>
                    ))}
                </tfoot>
            </table>
            <div className="h-2" />
            <Pagination canLoadMore={canLoadMore} manualPagination={manualPagination} tableLib={table} loadUser={loadUser} sizes={[20, 30, 50]} />
        </div>
    );
});


